export default "__VITE_ASSET__e1e40cf0__"